var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { pathOr } from 'ramda';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import Collapse from '@material-ui/core/Collapse';
import Button from '@material-ui/core/Button';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
var VARIANT_ICON = 'icon';
export var VARIANT_BOLD = 'bold';
var useStyles = makeStyles(function (theme) {
  var _ref;
  return _ref = {
    buttonExpand: {
      display: 'flex',
      justifyContent: 'space-between'
    }
  }, _ref['button' + VARIANT_ICON] = {
    color: theme.palette.primary.main,
    backgroundColor: 'rgba(24, 32, 38, 0.04)',
    margin: theme.spacing(1, 0)
  }, _ref['button' + VARIANT_BOLD] = _extends({
    marginBottom: theme.spacing(1),
    padding: theme.spacing(0.5, 0, 1, 0),
    '&:hover': {
      backgroundColor: 'unset'
    }
  }, pathOr({}, ['mixins', 'collapsibleTree', 'buttonSublevel'], theme)), _ref['collapsibleContainer' + VARIANT_BOLD] = {
    borderTop: '2px solid black',
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2)
  }, _ref;
});
var CollapseComponent = function CollapseComponent(_ref2) {
  var label = _ref2.label,
    isOpen = _ref2.isOpen,
    children = _ref2.children,
    _ref2$variant = _ref2.variant,
    variant = _ref2$variant === undefined ? VARIANT_ICON : _ref2$variant,
    level = _ref2.level;
  var classes = useStyles();
  var theme = useTheme();
  var _React$useState = React.useState(isOpen),
    open = _React$useState[0],
    setOpen = _React$useState[1];
  useEffect(function () {
    return setOpen(isOpen);
  }, [isOpen]);
  return React.createElement('div', {
    className: cx(classes['collapsibleContainer' + variant]),
    style: {
      marginRight: theme.spacing(level * 2),
      marginLeft: theme.spacing(level * 2)
    }
  }, React.createElement(Button, {
    className: cx(classes.buttonExpand, classes['button' + variant]),
    onClick: function onClick() {
      return setOpen(!open);
    },
    fullWidth: true
  }, label, open ? React.createElement(KeyboardArrowUpIcon, {
    color: 'primary'
  }) : React.createElement(KeyboardArrowDownIcon, {
    color: 'primary'
  })), React.createElement(Collapse, {
    'in': open,
    timeout: 'auto'
  }, children));
};
CollapseComponent.propTypes = process.env.NODE_ENV !== "production" ? {
  label: PropTypes.string,
  isOpen: PropTypes.bool,
  children: PropTypes.node,
  variant: PropTypes.oneOf([VARIANT_ICON, VARIANT_BOLD]),
  level: PropTypes.number
} : {};
export default CollapseComponent;